export default __webpack_public_path__ + "static/media/logo.025ef092.svg";